import { render, staticRenderFns } from "./VehicleTypeEdit.vue?vue&type=template&id=18a0071e"
import script from "./VehicleTypeEdit.vue?vue&type=script&lang=js"
export * from "./VehicleTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports